import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { queryClient, queryPersister, refreshToken } from '~/api'
import './index.css'
import { routeTree } from './routeTree.gen'
import { setupBookmarklets } from './utils/bookmarklets'
import { decodeJwt } from './utils/utils'

if (import.meta.env.VITE_DOWN_FOR_MAINTENANCE === 'true' && window.location.pathname !== '/maintenance' && localStorage.getItem('bypass-maintenance') == null) {
	window.location.href = '/maintenance'
} else if (window.location.pathname === '/') {
	const searchParams = new URLSearchParams(new URL(window.location.href).search)
	const token = searchParams.get('ltik') ?? localStorage.getItem('token')
	if (token != null && token.length > 0) {
		localStorage.setItem('token', token)
	} else {
		history.pushState({}, '', '/no-token')
	}

	const jwt = decodeJwt(token)
	const tokenCourseId = jwt.payload.canvasSisCourseId
	const tokenRole = jwt.payload.role
	history.pushState({}, '', tokenRole === 'student' ? `/student/courses/${tokenCourseId}` : `educator/courses/${tokenCourseId}/apps`)
} else if (localStorage.getItem('token') == null && window.location.pathname !== '/maintenance') {
	history.pushState({}, '', '/no-token')
}

setInterval(
	() => {
		void refreshToken()
	},
	1000 * 60 * 60, // 1 hour
)

// Create a new router instance
const router = createRouter({
	routeTree,
	defaultPreload: 'intent',
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}

const root = document.getElementById('root')
if (root == null) throw new Error('Root element not found')

ReactDOM.createRoot(root).render(
	<React.StrictMode>
		<PersistQueryClientProvider
			client={queryClient}
			persistOptions={{ persister: queryPersister }}
		>
			<RouterProvider router={router} />
			<ReactQueryDevtools initialIsOpen={false} />
		</PersistQueryClientProvider>
		{/*<NetworkErrorHandling />*/}
	</React.StrictMode>,
)

setupBookmarklets()
